import React, { FunctionComponent, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { listStyles, rotate } from '../../utilities/styles';
import { ListItem } from '../../utilities/list-item';
import { WorkCard } from './work-card';

// type Work = 'webinar' |  'cflDemo' | 'typescript';

interface MyWorkProps extends HTMLAttributes<HTMLDivElement> {}

const UnstyledMyWork: FunctionComponent<MyWorkProps> = (props) => {
  const pgtDescription = (
    <div>
      <p>Emilia Russo-Giometti, Nisha Devasia, and Alexis Hiniker. 2026. How Romantic Partners Build "Sound Relationship Houses" through Shared Gaming. <em>Proc. ACM Hum.-Comput. Interact.</em> 10, 7, Article GAMES038 (November 2026), 36 pages. <a href="https://doi.org/10.1145/3831343">https://doi.org/10.1145/3831343</a></p>
      <p><a href="https://faculty.washington.edu/alexisr/PGT.pdf">Pre-print available here.</a></p>
    </div>
  );
  // const teachingDescription = (
  //   <span>I have frequently worked as a TA for undergraduate courses covering research methods, game design, and interaction design.</span>
  // )
  const webinarDescription = (
    <span>
      A coworker and I made some goofy mistakes when we used React's Context API for the first time.
      We captured our learnings in a <a href="https://brandfolder.engineering/useContext-performance-issue">blog post</a> and partnered with an application monitoring platform to present a webinar about our learnings.
    </span>
  );
  // const cheerDescription = (
  //   <span>
  //     I was a cheerleader for the University of Chicago my entire undergraduate career.
  //     In 2017, I rebuilt the <a href="https://cheerleading.uchicago.edu">team's website</a> in AngularJS.
  //     I recently revisited it to make a few tweaks, revise the mobile experience, and support the current team in updating the information.
  //   </span>
  // );
  const thisSiteDescription = (
    <div>
      This site is a React app built with Create React App with SCSS and TypeScript and hosted via Firebase.&nbsp;
      <span className="desktop-hidden">My main focus for this iteration of the site was accessibility, theming, and new deployment practices.</span>
      <span className="mobile-hidden">My main goals for this iteration of the site were to</span>
        <ul className="mobile-hidden">
          <ListItem>
            <span>move away from GitHub pages to hosting with Firebase and deploying with GitHub actions</span>
          </ListItem>
          <ListItem>
            <span>fully adhere to the Web Consortium Accessibility Guidelines</span>
          </ListItem>
          <ListItem>
            <span>explore styled components and theming</span>
          </ListItem>
        </ul>
    </div>
  );
  const eatiDescription = (
    <div>
      Outside of my academic work, I host a podcast with my good friend,
      {' '}<a href="https://annienazzaro.com">Annie Nazzaro</a>.
      Every other week, we discuss indie video games we're playing.
      You can listen on{' '}
      <a href="https://open.spotify.com/show/48Y1fGZIiR6V6BR6MGx8d4?si=7465812c13f64869">Spotify</a>{', '}
      <a href="https://podcasts.apple.com/us/podcast/emmi-annie-talk-indie/id1788230718">Apple Podcasts</a>, and most other{' '}
      <a href="https://www.buzzsprout.com/2428722/follow">podcast services</a>.
      Or, you can listen on <a href="https://eati.games">our website</a>, which I created and maintain.
    </div>
  );

  return (
    <div {...props} id="my-work">
      <WorkCard title="ACM CHI PLAY 2026" containsCitation description={pgtDescription}>
        <img
          alt="On the left a shared gaming diagram is laid over a brick. The shared gaming diagram is made up of three pieces: shared gaming needs, play strategy, and game design. The three pieces fit neatly into each other like puzzle pieces. On the right is a brick house with the characteristics of the Sound Relationship House inside. There are three lines from the brick diagram to the brick house, implying that the shared gaming brick is three different bricks in the brick house."
          id="pgt"
          src={`${process.env.PUBLIC_URL}/pgt.png`}
        />
      </WorkCard>
      {/* <WorkCard title="Teaching" description={teachingDescription}>
        <img
          alt=""
          id="uwLogo"
          src={`${process.env.PUBLIC_URL}/uw.png`}
        />
      </WorkCard> */}
      <WorkCard title="Webinar: Diagnosing React Performance Issues" description={webinarDescription}>
        <iframe
          allowFullScreen
          className="mobile-hidden"
          width="400"
          height="225"
          src="https://www.youtube.com/embed/uFgdC3ilx54?si=wqpOxqTE79-Axkvw&amp;start=1307"
          title="React Context Performance Webinar"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        />
        <iframe
          allowFullScreen
          className="desktop-hidden"
          width="270"
          height="152"
          src="https://www.youtube.com/embed/uFgdC3ilx54?si=wqpOxqTE79-Axkvw&amp;start=1307"
          title="React Context Performance Webinar"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        />
      </WorkCard>
      {/* <WorkCard flexContent title="cheerleading.uchicago.edu" description={cheerDescription}>
        <img
          alt="screen capture of desktop view of cheerleading website"
          id="cheer-desktop"
          src={`${process.env.PUBLIC_URL}/CheerDesktop.png`}
        />
        <img
          alt="screen capture of mobile view of cheerleading website"
          id="cheer-mobile"
          src={`${process.env.PUBLIC_URL}/CheerMobile.png`}
        />
      </WorkCard> */}
      <WorkCard absoluteDescription title="emmi.dev" description={thisSiteDescription}>
        <div className="icon__container">
          <span aria-hidden className="icon__top material-symbols-outlined">filter_vintage</span>
          <span aria-hidden className="icon__base material-symbols-outlined">laptop</span>
        </div>
      </WorkCard>
      <WorkCard title="Emmi &amp; Annie Talk Indie" description={eatiDescription}>
        <img
          alt=""
          id="eati"
          src={`${process.env.PUBLIC_URL}/eati.png`}
        />
      </WorkCard>
    </div>
  );
};

const StyledMyWork = styled(UnstyledMyWork)`
  ${rotate}

  justify-content: center;
  gap: 26px;
  display: flex;
  max-width: 100%;
  flex-wrap: wrap;

  ul {
    ${listStyles}
  }

  @media only screen and (min-width: 2560px) {
    justify-content: flex-start;
    gap: 50px;
  }

  @media only screen and (min-width: 1280px) and (max-width: 2559px) {
    justify-content: space-evenly;
  }

  iframe, img {
    border: 0;
    border-radius: 6px;
    box-shadow: 0 6px 6px rgba(0,0,0,0.2);
  }

  .icon {
    &__base, &__top {
      position: absolute;
      color: ${props => props.theme.color}
    }

    &__base {
      font-size: 12em;
      left: 54px;
      top: 31px;
      color: ${props => props.theme.iconColor};

      @media(min-width: 430px) {
        left: 129px;
        top: auto;
      }
    }

    &__top {
      font-size: 6em;
      left: 102px;
      top: 66px;
      animation: rotate 5s linear infinite;

      @media(prefers-reduced-motion) {
        animation: none;
      }

      @media(min-width: 430px) {
        left: 177px;
        top: 96px;
      }
    }
  }

  #cheer-desktop {
    width: 200px;

    @media(min-width: 430px) {
      width: 300px;
    }
  }

  #cheer-mobile {
    height: 100px;
    margin-top: 44px;
    margin-left: -32px;

    @media(min-width: 430px) {
      height: 150px;
    }
  }

  #eati {
    width: 150px;

    @media(min-width: 430px) {
      width: 200px;
    }
  }

  #pgt, #uwLogo {
    width: 270px;

    @media(min-width: 430px) {
      width: 400px;
    }
  }
`;

export const MyWork: FunctionComponent<MyWorkProps> = (props) => (
  <StyledMyWork {...props} />
);
